if (!customElements.get('gift-packaging')) {
  customElements.define(
    'gift-packaging',
    class GiftPackaging extends HTMLElement {
      constructor() {
        super();
        this.selectedVariantId = null;
      }

      connectedCallback() {
        this.rows = this.querySelectorAll('[data-gift-packaging-row]');
        this.initEvents();
      }

      initEvents() {
        this.rows.forEach((row) => {
          row.addEventListener('click', () => {
            const variantId = row.dataset.variantId;
            if (!variantId) return;

            if (this.selectedVariantId === variantId) {
              this.setSelected(null);
              return;
            }

            this.setSelected(variantId);
          });
        });
      }

      setSelected(variantId) {
        this.selectedVariantId = variantId;
        let price = 0;

        this.rows.forEach((row) => {
          const isSelected = Boolean(variantId) && row.dataset.variantId === variantId;
          row.classList.toggle('is-selected', isSelected);
          row.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

          if (isSelected) {
            price = Number(row.dataset.price) || 0;
          }
        });

        this.dispatchEvent(
          new CustomEvent('gift-packaging:change', {
            bubbles: true,
            detail: { variantId, price },
          })
        );
      }

      reset() {
        this.setSelected(null);
      }
    }
  );
}
